// extracted by mini-css-extract-plugin
module.exports = {"mobileControls":"MobileMenuContent_mobileControls__U9lZ3","mobileCancelButton":"MobileMenuContent_mobileCancelButton__2v6no"};